import React, { useRef, useState, useEffect } from "react";
import axios from "../utils/axiosConfig";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getFile } from "../redux/actions/fileActions";
import { setNotifications } from '../redux/actions/notificationActions';

import { fetchFiles } from "../redux/actions/fileActions";
import { getTimesheetsByCaseId } from "../redux/actions/timesheetActions";
import {
  Box,
  Card,
  CardContent,
  Grid,
  FormControl,
  TextField,
  Autocomplete,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  MenuItem,
  Checkbox,
  FormGroup,
  FormControlLabel,
  InputAdornment,
  Select,
  CircularProgress,
  Container,
  Snackbar,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CustomAutocomplete from "../components/CustomAutocomplete";
import FileAutocomplete from "../components/FileAutocomplete";
import {
  createTimesheet,
  listTimesheets,
} from "../redux/actions/timesheetActions";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SubmitButton from "../components/SubmitButton";
import CancelButton from "../components/CancelButton";
import BreadcrumbNav from "../components/BreadcrumbNav";
import { windowsTableStyles } from "../styles/windowsTableStyles";
import { textFieldStyles } from "../styles/textFieldStyles";
import { smallBold, typoThin } from "../styles/typography";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import TimesheetSelector from '../components/TimesheetSelector';

const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Breadcrumbs will be set dynamically with translations

const BulkTimesheetPage = () => {
  const { t } = useTranslation(['pages', 'forms', 'buttons', 'common', 'messages', 'navigation']);
  const dispatch = useDispatch();
  const tableStyles = windowsTableStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [timesheetsList, setTimesheets] = useState([{}]);
  const { timesheets } = useSelector((state) => state.timesheetList);
  const { file } = useSelector((state) => state.fileDetails);
  const [id, setId] = useState(location.state?.caseId);
  const [totalDurationDisplay, setTotalDurationDisplay] = useState("");
  const [totalDuration, setTotalDuration] = useState("");
  const [totalAmount, setTotalAmount] = useState(0); // Ensure it's initialized as a number
  const files = useSelector((state) => state.fileList.files || []);
  const relationships = useSelector(
    (state) => state.relationshipList.relationships || []
  );
  const { user } = useSelector((state) => state.userLoaded); // Assuming user info is stored in auth state
  const [ownerHourlyRate, setOwnerHourlyRate] = useState(0); // Changed initial value to 0

  const [loading2, setLoading2] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    if (user) {
      setUserRole(user?.role);
    }
  }, [user]);

  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: t('navigation:home'), href: "/" },
    { label: t('navigation:timesheets'), href: "/timesheets" },
  ]);

  useEffect(() => {
    console.log("location", location.state?.caseId);
  }, [location]);
  const [formData, setFormData] = useState(() => {
    const locationCaseId = location.state?.caseId;
    const initialCaseFile =
      files?.find((file) => file._id === locationCaseId) || null;

    if (initialCaseFile) {
      setBreadcrumbs((prevBreadcrumbs) => [
        ...prevBreadcrumbs,
        {
          label: initialCaseFile.name || t('common:case_file'),
          href: `/files/${initialCaseFile._id}/timesheets`,
        },
      ]);
    }
    // const storedCaseId = localStorage.getItem("selectedCaseId");
    // const initialCaseFile = locationCaseId; //|| storedCaseId || "";

    return {
      owner: "",
      type: "",
      description: "",
      date: getCurrentDate(),
      case: locationCaseId,
    };
  });

  function parseDurationToHours(timeString) {
    const [hh, mm, ss] = timeString.split(":").map(Number);
    return hh + mm / 60 + ss / 3600;
  }

  useEffect(() => {
    if (user && timesheetsList.length == 1) {
      setFormData({ ...formData, owner: user.relationship });

      // Initialize with file's rate instead of user's rate
      const selectedFile = files.find(file => file._id === formData.case);
      const fileRate = selectedFile?.rateConfig?.type === 'hourly' ? selectedFile.rateConfig.hourlyRate : 0;

      setTimesheets(prevTimesheets => {
        const updatedTimesheets = [...prevTimesheets];
        updatedTimesheets[0].billingItems = [
          {
            type: "working_time",
            rate: fileRate,
            quantity: "00:00:00",
            billable: true,
          }
        ];
        updatedTimesheets[0].date = getCurrentDate();
        updatedTimesheets[0].owner = user.relationship;
        updatedTimesheets[0].case = formData.case;
        return updatedTimesheets;
      });
    }
  }, [user, files, formData.case]); // Add files and formData.case to dependencies

  useEffect(() => {
    console.log(timesheetsList);
  }, [timesheetsList]);

  const handleTimesheetChange = (index, event, applyToAll = false) => {
    const { name, value } = event.target;

    // Only update expanded state for type changes
    if (name === "type") {
      const newExpanded = [...expanded];
      newExpanded[index] = true;
      setExpanded(newExpanded);
    }

    const updatedTimesheets = [...timesheetsList];
    // Only apply to all timesheets for owner changes, not case changes
    if (applyToAll && name !== 'case') {
      updatedTimesheets.forEach((timesheet, idx) => {
        updatedTimesheets[idx][name] = value;
      });
    } else {
      updatedTimesheets[index][name] = value;
    }
    setTimesheets(updatedTimesheets);
  };

  // Modify the onChange handler to apply the change to all timesheets
  const handleOwnerChange = (event, newValue) => {
    setFormData({ ...formData, owner: newValue?._id || "" });
    const changeEvent = {
      target: {
        name: "owner",
        value: newValue?._id || "",
      },
    };
    handleTimesheetChange(0, changeEvent, true);
  };

  // Update handleCaseChange to handle rate configuration
  const handleCaseChange = (event, newValue) => {
    const fileId = newValue?._id || "";
    
    // Only update the formData state, which will be used for new timesheets
    setFormData({ ...formData, case: fileId });
    
    // Get the selected file's rate configuration
    const selectedFile = files.find(file => file._id === fileId);
    if (selectedFile && selectedFile.rateConfig) {
      const newRate = selectedFile.rateConfig.type === 'hourly' ? selectedFile.rateConfig.hourlyRate : 0;
      setOwnerHourlyRate(newRate);
    }
    
    // No longer updating any existing timesheets here
  };

  //   const handleBillingItemChange = (timesheetIndex, billingItemIndex, event) => {
  //     const { name, checked, type: inputType } = event.target;
  //     const value = inputType === "checkbox" ? checked : event.target.value;
  //     const updatedTimesheets = [...timesheetsList];

  //     // If changing the type to kilometers, reset the quantity
  //     if (name === "type" && value === "kilometers") {
  //         updatedTimesheets[timesheetIndex].billingItems[billingItemIndex].quantity = "0";
  //     }

  //     if (name === "quantity") {
  //         let newValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
  //         if (newValue.length > 4) {
  //             newValue =
  //                 newValue.slice(0, 2) +
  //                 ":" +
  //                 newValue.slice(2, 4) +
  //                 ":" +
  //                 newValue.slice(4, 6);
  //         } else if (newValue.length > 2) {
  //             newValue = newValue.slice(0, 2) + ":" + newValue.slice(2, 4);
  //         }
  //         updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = newValue;
  //     } else {
  //         updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = value;
  //     }

  //     setTimesheets(updatedTimesheets);
  // };

  // Update handleAddTimesheet to use file's rate configuration

  // const handleBillingItemChange = (timesheetIndex, billingItemIndex, event) => {
  //   const { name, checked, type: inputType } = event.target;
  //   const value = inputType === "checkbox" ? checked : event.target.value;
  //   const updatedTimesheets = [...timesheetsList];

  //   if (name === "quantity") {
  //     if (updatedTimesheets[timesheetIndex].billingItems[billingItemIndex].type === "kilometers") {
  //       // Allow only numeric input for kilometers
  //       updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = value.replace(/[^0-9]/g, "");
  //     } else {
  //       // Format as hh:mm:ss for other types
  //       let newValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
  //       if (newValue.length > 4) {
  //         newValue =
  //           newValue.slice(0, 2) +
  //           ":" +
  //           newValue.slice(2, 4) +
  //           ":" +
  //           newValue.slice(4, 6);
  //       } else if (newValue.length > 2) {
  //         newValue = newValue.slice(0, 2) + ":" + newValue.slice(2, 4);
  //       }
  //       updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = newValue;
  //     }
  //   } else {
  //     updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = value;
  //   }

  //   setTimesheets(updatedTimesheets);
  // };

  const handleBillingItemChange = (timesheetIndex, billingItemIndex, event) => {
    const { name, checked, type: inputType } = event.target;
    const value = inputType === "checkbox" ? checked : event.target.value;
    const updatedTimesheets = [...timesheetsList];

    if (name === "type") {
      // Reset quantity based on the new type
      const defaultQuantity = value === "kilometers" ? "0" : "00:00:00";
      updatedTimesheets[timesheetIndex].billingItems[billingItemIndex].quantity = defaultQuantity;
      updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = value;
    } else if (name === "quantity") {
      if (updatedTimesheets[timesheetIndex].billingItems[billingItemIndex].type === "kilometers") {
        // Allow only numeric input for kilometers
        updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = value.replace(/[^0-9]/g, "");
      } else {
        // Format as hh:mm:ss for other types
        let newValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
        if (newValue.length > 4) {
          newValue =
            newValue.slice(0, 2) +
            ":" +
            newValue.slice(2, 4) +
            ":" +
            newValue.slice(4, 6);
        } else if (newValue.length > 2) {
          newValue = newValue.slice(0, 2) + ":" + newValue.slice(2, 4);
        }
        updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = newValue;
      }
    } else {
      updatedTimesheets[timesheetIndex].billingItems[billingItemIndex][name] = value;
    }

    setTimesheets(updatedTimesheets);
  };


  useEffect(() => {
    console.log("timesheets list", timesheetsList);
  }, [timesheetsList]);

  const handleAddTimesheet = (templateTimesheet) => {
    const selectedFile = files.find(file => file._id === formData.case);
    const rate = selectedFile?.rateConfig?.type === 'hourly' ? selectedFile.rateConfig.hourlyRate : 0;

    // Check if a timesheet is selected for cloning
    if (templateTimesheet) {
      // Format the date from the selected timesheet
      let clonedDate = getCurrentDate(); // Default to current date as fallback
      try {
        if (templateTimesheet.date) {
          const dateObj = new Date(templateTimesheet.date);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const day = String(dateObj.getDate()).padStart(2, "0");
          clonedDate = `${year}-${month}-${day}`;
        }
      } catch (e) {
        console.error('Error formatting date for cloning:', e);
      }

      // Clone the timesheet with the same date
      setTimesheets([
        ...timesheetsList,
        {
          owner: formData.owner,
          type: "", // Reset type
          date: clonedDate, // Use the date from the template timesheet
          case: formData.case, // Use current case
          description: "", // Reset description
          billingItems: [
            {
              type: "working_time", // Reset to default type
              rate: rate, // Use current rate
              quantity: "00:00:00", // Reset quantity
              billable: true, // Default to billable
            },
          ],
        },
      ]);
      // Reset the selected timesheet after adding
      setSelectedTimesheet(null);
    } else {
      // Create a completely blank timesheet
      setTimesheets([
        ...timesheetsList,
        {
          owner: formData.owner,
          type: "",
          date: getCurrentDate(),
          case: formData.case,
          description: "",
          billingItems: [
            {
              type: "working_time",
              rate: rate,
              quantity: "00:00:00",
              billable: true,
            },
          ],
        },
      ]);
    }
  };

  const handleDeleteTimesheet = (index) => {
    const updatedTimesheets = timesheetsList.filter((_, i) => i !== index);
    setTimesheets(updatedTimesheets);
  };

  // Update handleAddBillingItem to use file's rate configuration
  const handleAddBillingItem = (timesheetIndex) => {
    // Get the case from the specific timesheet
    const timesheetCase = timesheetsList[timesheetIndex].case;
    const selectedFile = files.find(file => file._id === timesheetCase);
    const rate = selectedFile?.rateConfig?.type === 'hourly' ? selectedFile.rateConfig.hourlyRate : 0;

    const updatedTimesheets = [...timesheetsList];
    updatedTimesheets[timesheetIndex].billingItems?.push({
      type: "working_time",
      rate: rate,
      quantity: "00:00:00",
      billable: true,
    });
    setTimesheets(updatedTimesheets);
  };

  const handleDeleteBillingItem = (timesheetIndex, billingItemIndex) => {
    const updatedTimesheets = [...timesheetsList];
    updatedTimesheets[timesheetIndex].billingItems.splice(billingItemIndex, 1);
    setTimesheets(updatedTimesheets);
  };

  const { loading, success, error } = useSelector(
    (state) => state.timesheetCreate
  );

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const hasNavigated = useRef(false); // Define the flag using useRef

  useEffect(() => {
    const runAsync = async () => {
      if (success) {
        setNotification({
          open: true,
          message: t('messages:timesheets_created_successfully'),
          severity: "success",
        });
        dispatch({ type: "TIMESHEET_CREATE_RESET" }); // Reset the success state
        dispatch(fetchFiles());
        dispatch(getFile(id));

        dispatch(getTimesheetsByCaseId(id));
        // Then compare sums with file's alarm settings

        setTimeout(() => { }, 2000);
        // console.log("timesheets", timesheets);
        const sumHours = timesheets?.reduce((acc, ts) => {
          return acc + parseDurationToHours(ts.totalDuration);
        }, 0);
        const sumFees = timesheets?.reduce(
          (acc, ts) => acc + ts.totalAmount,
          0
        );
        // Use the case ID from the first timesheet or the formData as fallback
        const relevantCaseId = timesheetsList[0]?.case || formData.case;
        const hourLimit = files.find((file) => file._id === relevantCaseId)?.signalingHours;
        const feeLimit = files.find((file) => file._id === relevantCaseId)?.limitOnFees;
        const percent = files.find((file) => file._id === relevantCaseId)?.warningThreshold / 100;
        let showNotification = false;
        // console.log("hh ", hourLimit, feeLimit);
        if (!files.find((file) => file._id === relevantCaseId)?.notificationShown) {
          if (
            sumHours >= hourLimit * (0.01 * percent) ||
            sumFees >= feeLimit * (0.01 * percent)
          ) {
            showNotification = true;
          }
        }
        console.log(showNotification);
        if (showNotification) {
          // Trigger UI notification
          // console.log("You have worked over a specified limit for this case File");
          // Mark notification as shown in the DB
          await axios.put(`/api/files/${id}`, { notificationShown: true });
          await axios.post('/api/notifications', {
            user: user?.relationship,
            type: 'File',
            subject: 'Work limit exceeded for this case File',
            file: id
          });
          dispatch(getFile(id)); // refresh store
          const res = await axios.get(`/api/notifications/${user._id}`);
          setTimeout(() => { }, 2000);
          dispatch(setNotifications(res.data));
        }
        if (!hasNavigated.current) { // Check the flag before executing the navigation code
          // setTimeout(() => {
          //   navigate(-1);
          // }, 1000);
          hasNavigated.current = true; // Set the flag to true after the navigation code runs
        }
        // window.location.reload(true);
        // navigate('/documents');
      } else if (error) {
        setNotification({
          open: true,
          message: error,
          severity: "error",
        });
        dispatch({ type: "TIMESHEET_CREATE_RESET" }); // Reset the error state
      }
    };
    runAsync();
  }, [success, error, dispatch]);

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  useEffect(() => {
    let durationSum = 0;
    let total = 0;

    timesheetsList.forEach((timesheet) => {
      timesheet.billingItems?.forEach((item) => {
        if (item.type !== "kilometers") {
          const [hours, minutes, seconds] = item.quantity
            .split(":")
            .map(Number);
          const decimalHours = hours + minutes / 60 + seconds / 3600; // Convert to decimal hours
          durationSum += decimalHours;
          total += decimalHours * parseFloat(item.rate);
        } else {
          const amount = parseFloat(item.quantity) * parseFloat(item.rate);
          total += amount;
        }
      });
    });

    // Convert decimal hours to hours, minutes, and seconds
    const totalHours = Math.floor(durationSum);
    const totalHours2Digit = Math.floor(durationSum)
      .toString()
      .padStart(2, "0");
    const totalMinutes = Math.floor((durationSum - totalHours) * 60);
    const totalSeconds = Math.round(
      ((durationSum - totalHours) * 60 - totalMinutes) * 60
    );
    const totalMinutes2Digit = Math.floor((durationSum - totalHours) * 60)
      .toString()
      .padStart(2, "0");
    const totalSeconds2Digit = Math.round(
      ((durationSum - totalHours) * 60 - totalMinutes) * 60
    )
      .toString()
      .padStart(2, "0");
    const totalDurationDigitsOnly = `${totalHours2Digit}:${totalMinutes2Digit}:${totalSeconds2Digit}`;
    const formattedDuration = `${totalHours}h: ${totalMinutes}m: ${totalSeconds}s`;

    setTotalDurationDisplay(formattedDuration);
    setTotalDuration(totalDurationDigitsOnly); // Set the total duration in hours, minutes, and seconds format
    setTotalAmount(parseFloat(total.toFixed(2))); // Set the total amount with 2 decimal places as a number
  }, [timesheetsList]);

  const billingItemTypes = [
    { value: "working_time", label: t('pages:timesheets.working_time') },
    { value: "travel_time", label: t('pages:timesheets.travel_time') },
    { value: "kilometers", label: t('pages:timesheets.kilometers') }
  ];
  const predefinedQuantities = [
    "00:00:00",
    "00:06:00",
    "00:12:00",
    "00:18:00",
    "00:24:00",
    "00:30:00",
    "00:36:00",
    "00:42:00",
    "00:48:00",
    "00:54:00",
    "01:00:00",
    "01:06:00",
    "01:12:00",
    "01:18:00",
    "01:24:00",
    "01:30:00",
    "01:36:00",
    "01:42:00",
    "01:48:00",
    "01:54:00",
    "02:00:00",
    "02:06:00",
    "02:12:00",
    "02:18:00",
    "02:24:00",
    "02:30:00",
    "02:36:00",
    "02:42:00",
    "02:48:00",
    "02:54:00",
    "03:00:00",
  ];
  const activityTypes = [
    { label: "COCL - Correspondentie aan/van cliënt" },
    { label: "COVE - Correspondentie aan/van verzekeraar" },
    { label: "COSC - Correspondentie aan/van schaderegelaar" },
    { label: "COTE - Correspondentie aan/van (advocaat) tegenpartij" },
    { label: "COON - Correspondentie aan/van (toedrachts)onderzoeker" },
    { label: "COWE - Correspondentie aan/van werkgever" },
    { label: "COEX - Correspondentie aan/van (schade)expert" },
    { label: "COFT - Correspondentie aan/van fysiotherapeut" },
    { label: "COPO - Correspondentie aan/van Politie / OM" },
    { label: "COFI - Correspondentie aan/van (financieel) deskundige" },
    { label: "COAR - Correspondentie aan/van arbeidsdeskundige" },
    { label: "COAI - Correspondentie aan/van arbeidsinspectie" },
    { label: "COBE - Correspondentie aan/van bestuursorgaan" },
    { label: "COBO - Correspondentie aan/van boekhouder" },
    { label: "COMATGP - Correspondentie aan/van medisch adviseur tegenpartij" },
    { label: "COMA - Correspondentie aan/van medisch adviseur" },
    { label: "COZO - Correspondentie aan/van zorgverzekeraar" },
    { label: "CODE - Correspondentie aan/van derde" },
    { label: "COHU - Correspondentie aan/van huisarts" },
    { label: "COZIE - Correspondentie aan/van ziekenhuis" },
    { label: "COPS - Correspondentie aan/van psycholoog" },
    { label: "CORE - Correspondentie aan/van revalidatiearts" },
    { label: "COVER - Correspondentie aan/van verpleeghuis" },
    { label: "COBED - Correspondentie aan/van bedrijfsarts" },
    { label: "COOR - Correspondentie aan/van orthopeed" },
    { label: "COER - Correspondentie aan/van ergotherapeut" },
    { label: "COTA - Correspondentie aan/van tandarts" },
    { label: "COG - Correspondentie aan/van gemeente" },
    { label: "COU - Correspondentie aan/van UWV" },
    { label: "CORE - Correspondentie aan/van rechterlijke macht" },
    { label: "CODE - Correspondentie aan/van deurwaarder" },
    { label: "TECL - Telefoongesprek met cliënt" },
    { label: "TEMA - Telefoongesprek met medisch adviseur" },
    { label: "TETE - Telefoongesprek met (advocaat) tegenpartij" },
    { label: "TEMATGP - Telefoongesprek met medisch adviseur tegenpartij" },
    { label: "TEUW - Telefoongesprek met UWV" },
    { label: "TEGE - Telefoongesprek met gemeente" },
    { label: "TEZIE - Telefoongesprek met ziekenhuis" },
    { label: "TEDE - Telefoongesprek met derde" },
    { label: "TEARINS - Telefoongesprek met arbeidsinspectie" },
    { label: "TEHU - Telefoongesprek met huisarts" },
    { label: "TEREVA - Telefoongesprek met revalidatiearts" },
    { label: "TEPSY - Telefoongesprek met psycholoog" },
    { label: "TESC - Telefoongesprek met schaderegelaar" },
    { label: "TEZO - Telefoongesprek met zorgverzekeraar" },
    { label: "TEBOE - Telefoongesprek met boekhouder" },
    { label: "TEERG - Telefoongesprek met ergotherapeut" },
    { label: "TEPO - Telefoongesprek met Politie / OM" },
    { label: "TEORT - Telefoongesprek met orthopeed" },
    { label: "TEVRP - Telefoongesprek met verpleeghuis" },
    { label: "TEEX - Telefoongesprek met (schade)expert" },
    { label: "TETA - Telefoongesprek met tandarts" },
    { label: "TEFYS - Telefoongesprek met fysiotherapeut" },
    { label: "TEWE - Telefoongesprek met werkgever" },
    { label: "TEBED - Telefoongesprek met bedrijfsarts" },
    { label: "TEOND - Telefoongesprek met (toedrachts)onderzoeker" },
    { label: "TEBE - Telefoongesprek met bestuursorgaan" },
    { label: "TEVE - Telefoongesprek met verzekeraar" },
    { label: "TEFI - Telefoongesprek met financieel deskundige" },
    { label: "TEARDE - Telefoongesprek met arbeidsdeskundige" },
    { label: "TERE - Telefoongesprek met rechterlijke macht" },
    { label: "TEDWR - Telefoongesprek met deurwaarder" },
    { label: "TERDW - Telefoongesprek met RDW" },
    { label: "BEKA - Bespreking met cliënt op kantoor" },
    { label: "BELO - Bespreking bij cliënt op locatie" },
    { label: "GEBECL - Gezamenlijk bezoek bij cliënt" },
    { label: "GEBEKA - Gezamenlijk bezoek op kantoor" },
    { label: "BECLE - Bespreking met cliënt elders" },
    { label: "BEDEE - Bespreking met derde elders" },
    { label: "BEDEKA - Bespreking met derde op kantoor" },
    { label: "VOBE - Voorbereiding van bespreking" },
    { label: "STUDLI - Studie literatuur en jurisprudentie" },
    { label: "STUO - Studie ontvangen stuk(ken)" },
    { label: "STUPRO - Studie ontvangen processtuk" },
    { label: "STUDIEDOS - Studie dossier" },
    { label: "DAG - (Ontwerp) dagvaarding" },
    { label: "VERZ - (Ontwerp) verzoek- of beroepschrift" },
    { label: "CONCL - (Ontwerp) conclusie, memorie, akte, verweerschrift" },
    { label: "PLEITNOTA - (Ontwerp) pleitnota" },
    { label: "OVK - (Ontwerp) overeenkomst" },
    { label: "PRODUC - Verzamelen / concipiëren bewijsstukken / producties" },
    { label: "VOORBER - (Voorbereiding) andere verrichtingen in rechte" },
    { label: "PLEID - Pleidooi / mondelinge behandeling" },
    { label: "ENQU - Bijwonen enquete" },
    { label: "COMP - Bijwonen comparitie" },
    { label: "ZITTING - Bijwonen (hoor)zitting" },
    { label: "BEZICHT - Bezichtiging ter plaatse" },
    { label: "REISCL - Reizen voor cliënt" },
    { label: "REISA - Reizen algemeen" },
    { label: "DIV - Diverse werkzaamheden" },
    { label: "FEITOND - (Feiten) onderzoek (internet, KvK, e.d.)" },
    { label: "OPPV - Opvragen proces-verbaal" },
    { label: "SCHADE - Opstellen schadestaat" },
    { label: "ALG - Algemeen" },
  ];

  // Filter files based on user role
  const filteredFiles = files.filter((file) => {
    if (userRole === "Manager") {
      return true; // Managers can see all files
    } else if (userRole === "Responsible Lawyer") {
      return file.officeMembers.some((member) => {
        // console.log('Member ID:', member.member._id);
        // console.log('User Relationship ID:', user.relationship);
        return (
          member.member._id === user.relationship &&
          member.role === "Responsible Lawyer"
        );
      });
    } else if (userRole === "Assistant Lawyer") {
      return file.officeMembers.some(
        (member) =>
          member.member._id === user.relationship &&
          member.role === "Treating Lawyer"
      );
    }
    return false;
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("timesheets list", timesheetsList);

    // Set loading state
    setLoading2(true);
    setNotification({
      open: false,
      message: "",
      severity: "info",
    });

    try {
      // Process timesheets sequentially to avoid race conditions
      for (let i = 0; i < timesheetsList.length; i++) {
        const timesheet = timesheetsList[i];
        const {
          owner,
          type,
          date,
          case: caseId,
          description,
          billingItems,
        } = timesheet;

        // ✅ Ensure description is always a string
        const safeDescription = typeof description === "string" ? description.trim() : "";

        let durationSum = 0;
        let total = 0;
        setId(caseId);

        billingItems.forEach((item) => {
          if (item.type !== "kilometers") {
            const [hours, minutes, seconds] = item.quantity
              .split(":")
              .map(Number);
            const decimalHours = hours + minutes / 60 + seconds / 3600; // Convert to decimal hours
            durationSum += decimalHours;
            total += decimalHours * parseFloat(item.rate);
          } else {
            const amount = parseFloat(item.quantity) * parseFloat(item.rate);
            total += amount;
          }
        });

        // Convert decimal hours to hours, minutes, and seconds
        const totalHours = Math.floor(durationSum);
        const totalHours2Digit = Math.floor(durationSum)
          .toString()
          .padStart(2, "0");
        const totalMinutes = Math.floor((durationSum - totalHours) * 60);
        const totalSeconds = Math.round(
          ((durationSum - totalHours) * 60 - totalMinutes) * 60
        );
        const totalMinutes2Digit = Math.floor((durationSum - totalHours) * 60)
          .toString()
          .padStart(2, "0");
        const totalSeconds2Digit = Math.round(
          ((durationSum - totalHours) * 60 - totalMinutes) * 60
        )
          .toString()
          .padStart(2, "0");
        const totalDurationDigitsOnly = `${totalHours2Digit}:${totalMinutes2Digit}:${totalSeconds2Digit}`;
        const formattedDuration = `${totalHours}h: ${totalMinutes}m: ${totalSeconds}s`;

        // let trimmed_description = description.trim();  // Ensure description is not empty
        // if (trimmed_description.length === 0) {
        //   trimmed_description = "";
        // }
          // Use axios directly instead of dispatch to ensure sequential processing
        try {
          const response = await axios.post('/api/timesheets', {
            formData: {
              owner,
              type,
              date,
              case: caseId,
              description: safeDescription,
            },
            billingItems,
            totalDuration: totalDurationDigitsOnly,
            totalAmount: total.toFixed(2),
          });

          console.log(`Timesheet ${i + 1}/${timesheetsList.length} created:`, response.data);

          // Small delay to prevent race conditions
          await new Promise(resolve => setTimeout(resolve, 300));
        } catch (error) {
          console.error(`Error creating timesheet ${i + 1}:`, error);
          throw error; // Rethrow to be caught by outer try/catch
        }
      }

      // All timesheets created successfully
      setNotification({
        open: true,
        message: t('messages:bulk_timesheets_created', { count: timesheetsList.length }),
        severity: "success",
      });

      // Reset form instead of navigating away
      setTimeout(() => {
        // Reset the form to allow creating more timesheets
        setTimesheets([{
          owner: formData.owner,
          type: "",
          date: getCurrentDate(),
          case: formData.case,
          description: "",
          billingItems: [
            {
              type: "working_time",
              rate: ownerHourlyRate,
              quantity: "00:00:00",
              billable: true,
            },
          ],
        }]);
      }, 1500);

    } catch (error) {
      console.error("Error creating timesheets:", error);
      setNotification({
        open: true,
        message: t('messages:error_creating_timesheets', { error: error.response?.data?.message || error.message }),
        severity: "error",
      });
    } finally {
      setLoading2(false);
    }
  };

  const handleCancel = () => {
    // Instead of navigating away, just reset the form
    setTimesheets([{
      owner: formData.owner,
      type: "",
      date: getCurrentDate(),
      case: formData.case,
      description: "",
      billingItems: [
        {
          type: "working_time",
          rate: ownerHourlyRate,
          quantity: "00:00:00",
          billable: true,
        },
      ],
    }]);
    
    // Show notification
    setNotification({
      open: true,
      message: t('messages:form_cleared'),
      severity: "info",
    });
  };

  const commonTextFieldStyles = {
    "& .MuiInputBase-root": {
      border: "none",
      padding: "0 8px", // Add small padding
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)", // Light grey background on hover
      },
    },
    "& .MuiInputLabel-root": {
      "&:hover": {
        color: "primary.main", // Change label color on hover
      },
    },
  };

  const [selectedTimesheet, setSelectedTimesheet] = useState(null);

  return (
    <Container
      style={{
        position: "relative",
        padding: 0,
        paddingBottom: "80px",
        width: "100%",
      }}
    >
      <BreadcrumbNav
        title={t('pages:timesheets.create_bulk_title')}
        breadcrumbs={breadcrumbs}
        showBreadcrumbs={true}
      />

      <Box
        sx={{
          backgroundColor: "white",
          padding: "30px 24px",
          marginTop: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <FormControl sx={{ width: "250px" }} required>
              <CustomAutocomplete
                options={relationships}
                value={
                  relationships.find((rel) => rel._id === formData.owner) ||
                  null
                }
                onChange={handleOwnerChange}
                label={t('common:owner')}
                filterType="Member"
                addNewLabel={t('pages:timesheets.add_owner')}
                addNewPath="/relationships/create"
              />
            </FormControl>
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TimesheetSelector 
                timesheets={timesheetsList.filter(ts => ts && ts.date && Object.keys(ts).length > 0) || []}
                selectedTimesheet={selectedTimesheet}
                onTimesheetSelect={(event, newValue) => setSelectedTimesheet(newValue)}
                onAddTimesheet={handleAddTimesheet}
                width="250px"
              />
            </Box>
          </Box>
        </Box>
        <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableContainer>
                <Table sx={tableStyles.container} size="small">
                  <TableHead>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Box
                        sx={{
                          ...tableStyles.headerCell,
                          width: "292px",
                          border: "none",
                          paddingLeft: "30px",
                        }}
                      >
                        {t('common:type')}
                      </Box>
                      <Box
                        sx={{
                          ...tableStyles.headerCell,
                          width: "164px",
                          border: "none",
                        }}
                      >
                        {t('common:date')}
                      </Box>
                      <Box
                        sx={{
                          ...tableStyles.headerCell,
                          width: "190px",
                          border: "none",
                        }}
                      >
                        {t('common:case')}
                      </Box>
                      <Box
                        sx={{
                          ...tableStyles.headerCell,
                          width: "300px",
                          border: "none",
                        }}
                      >
                        {t('common:description')}
                      </Box>
                      {/* <Box sx={{ ...tableStyles.headerCell, width: "100px" }}>
                        Action
                      </Box> */}
                    </Box>
                  </TableHead>
                  <TableBody sx={{ border: "none" }}>
                    {timesheetsList?.map((timesheet, timesheetIndex) => (
                      <React.Fragment
                        key={timesheetIndex}
                        sx={{ border: "none" }}
                      >
                        <Accordion
                          expanded={expanded[timesheetIndex] || false}
                          // sx={tableStyles.container}
                          sx={{
                            border: "none",
                            boxShadow: "none", // Remove the shadow
                            "&.MuiPaper-root": {
                              backgroundColor: "white", // Remove the background color
                            },
                            "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded":
                            {
                              transform: "rotate(90deg)",
                            },
                            "& .MuiAccordionSummary-expandIconWrapper": {
                              marginRight: "6px",
                              marginLeft: "6px",
                            },
                            "&.Mui-focusVisible": {
                              backgroundColor: "white", // Change to your desired color
                            },
                          }}
                          size="small"
                        >
                          <AccordionSummary
                            expandIcon={
                              <ArrowForwardIosSharpIcon
                                onClick={(event) => {
                                  event.stopPropagation();
                                  setExpanded((prev) => {
                                    const newExpanded = [...prev];
                                    newExpanded[timesheetIndex] =
                                      !newExpanded[timesheetIndex];
                                    return newExpanded;
                                  });
                                }}
                                style={{
                                  fontSize: "0.9rem",
                                  padding: "0",
                                  margin: "0",
                                  cursor: "pointer",
                                  backgroundColor: "white",
                                }}
                              />
                            }
                            onClick={(event) => event.stopPropagation()}
                            sx={{
                              cursor: "default",
                              padding: 0,
                              flexDirection: "row-reverse",
                              border: "none",
                              "&.Mui-focusVisible": {
                                backgroundColor: "white", // Change to your desired color
                              },
                            }}
                          >
                            <TableRow
                              sx={{
                                height: "36px",
                                border: "none",
                                padding: 0,
                              }}
                            >
                              <TableCell
                                sx={{
                                  ...typoThin,
                                  padding: "0 5px",
                                  border: "none",
                                  // padding: "8px 16px",
                                  // borderBottom: "1px solid #f0f0f0",
                                  lineHeight: "1",
                                  width: "300px",
                                }}
                              >
                                <Autocomplete
                                  options={activityTypes}
                                  getOptionLabel={(option) => option.label}
                                  onChange={(event, newValue) =>
                                    handleTimesheetChange(timesheetIndex, {
                                      target: {
                                        name: "type",
                                        value: newValue?.label || "",
                                      },
                                    })
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={t('common:type')}
                                      fullWidth
                                      size="small"
                                      sx={textFieldStyles()}
                                      required
                                    />
                                  )}
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  ...typoThin,
                                  padding: "0 5px",
                                  border: "none",
                                  // padding: "8px 16px",
                                  // borderBottom: "1px solid #f0f0f0",
                                  lineHeight: "1",
                                  width: "10px",
                                }}
                              >
                                <TextField
                                  type="date"
                                  label={t('common:date')}
                                  name="date"
                                  value={timesheet.date}
                                  onChange={(event) =>
                                    handleTimesheetChange(timesheetIndex, event)
                                  }
                                  fullWidth
                                  required
                                  size="small"
                                  sx={textFieldStyles()}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  ...typoThin,
                                  padding: "0 5px",
                                  border: "none",
                                  // padding: "8px 16px",
                                  // borderBottom: "1px solid #f0f0f0",
                                  lineHeight: "1",
                                  width: "200px",
                                }}
                              >
                                <FileAutocomplete
                                  options={filteredFiles}
                                  value={
                                    files.find(
                                      (file) => file._id === timesheet.case
                                    ) || null
                                  }
                                  onChange={(event, newValue) => {
                                    // Create a timesheet-specific case change handler
                                    const fileId = newValue?._id || "";
                                    
                                    // Get the selected file's rate configuration
                                    const selectedFile = files.find(file => file._id === fileId);
                                    
                                    // Update just this timesheet
                                    const updatedTimesheets = [...timesheetsList];
                                    
                                    if (selectedFile && selectedFile.rateConfig) {
                                      const newRate = selectedFile.rateConfig.type === 'hourly' 
                                        ? selectedFile.rateConfig.hourlyRate 
                                        : 0;
                                        
                                      // Update only this timesheet's billing items with the new rate
                                      if (updatedTimesheets[timesheetIndex].billingItems) {
                                        updatedTimesheets[timesheetIndex].billingItems = 
                                          updatedTimesheets[timesheetIndex].billingItems.map(item => ({
                                            ...item,
                                            rate: newRate
                                          }));
                                      }
                                    }
                                    
                                    // Update the case field for this timesheet
                                    updatedTimesheets[timesheetIndex].case = fileId;
                                    
                                    setTimesheets(updatedTimesheets);
                                  }}
                                  label={t('common:case')}
                                  name="case"
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  ...typoThin,
                                  padding: "0 5px",
                                  border: "none",
                                  // padding: "8px 16px",
                                  // borderBottom: "1px solid #f0f0f0",
                                  lineHeight: "1",
                                  width: "350px",
                                }}
                              >
                                <TextField
                                  label={t('common:description')}
                                  name="description"
                                  value={timesheet.description}
                                  onChange={(event) =>
                                    handleTimesheetChange(timesheetIndex, event)
                                  }
                                  sx={textFieldStyles()}
                                  multiline
                                  fullWidth
                                  size="small"
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  ...typoThin,
                                  padding: "0 5px",
                                  border: "none",
                                  // padding: "8px 16px",
                                  // borderBottom: "1px solid #f0f0f0",
                                  lineHeight: "1",
                                  width: "50px",
                                }}
                              >
                                <IconButton
                                  onClick={() =>
                                    handleDeleteTimesheet(timesheetIndex)
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                            {/* <Typography>Billing Items</Typography> */}
                          </AccordionSummary>
                          <AccordionDetails
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <TableRow
                              sx={{
                                backgroundColor: "#ECECEC",
                                padding: "20px",
                              }}
                            >
                              <TableCell
                                colSpan={6}
                                sx={{
                                  ...tableStyles.headerCell,
                                  border: "none",
                                }}
                              >
                                {/* <Accordion
                              expanded={expanded[timesheetIndex] || false}
                              sx={tableStyles.container} size="small"
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                onClick={() =>
                                  setExpanded((prev) => {
                                    const newExpanded = [...prev];
                                    newExpanded[timesheetIndex] =
                                      !newExpanded[timesheetIndex];
                                    return newExpanded;
                                  })
                                }
                              >
                              </AccordionSummary>
                              <AccordionDetails> */}
                                <TableContainer>
                                  <Table
                                    sx={tableStyles.container}
                                    size="small"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell sx={tableStyles.headerCell}>
                                          {t('common:type')}
                                        </TableCell>
                                        <TableCell sx={tableStyles.headerCell}>
                                          {t('common:rate')}
                                        </TableCell>
                                        <TableCell sx={tableStyles.headerCell}>
                                          {t('common:quantity')}
                                        </TableCell>
                                        {/* <TableCell sx={tableStyles.headerCell}>
                                          {t('common:status')}
                                        </TableCell> */}
                                        <TableCell sx={tableStyles.headerCell}>
                                          {t('common:amount')}
                                        </TableCell>
                                        <TableCell sx={tableStyles.headerCell}>
                                          Actions
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {timesheet.billingItems?.map(
                                        (item, billingItemIndex) => (
                                          <TableRow key={billingItemIndex}>
                                            <TableCell>
                                              <TextField
                                                select
                                                variant="standard"
                                                name="type"
                                                required
                                                value={item.type}
                                                onChange={(event) =>
                                                  handleBillingItemChange(
                                                    timesheetIndex,
                                                    billingItemIndex,
                                                    event
                                                  )
                                                }
                                                fullWidth
                                                InputProps={{
                                                  disableUnderline: true,
                                                }}
                                                sx={commonTextFieldStyles}
                                              >
                                                {billingItemTypes.map(
                                                  (type) => (
                                                    <MenuItem
                                                      key={type.value}
                                                      value={type.value}
                                                    >
                                                      {type.label}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </TextField>
                                            </TableCell>
                                            <TableCell>
                                              <TextField
                                                variant="standard"
                                                name="rate"
                                                type="number"
                                                required
                                                value={item.rate}
                                                onChange={(event) =>
                                                  handleBillingItemChange(
                                                    timesheetIndex,
                                                    billingItemIndex,
                                                    event
                                                  )
                                                }
                                                disabled={files.find(f => f._id === timesheet.case)?.rateConfig?.type !== 'hourly'}
                                                fullWidth
                                                InputProps={{
                                                  disableUnderline: true,
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      <Typography variant="body2">
                                                        €
                                                      </Typography>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={commonTextFieldStyles}
                                              />
                                            </TableCell>
                                            <TableCell>
                                              <TextField
                                                variant="standard"
                                                name="quantity"
                                                required
                                                value={item.quantity}
                                                onChange={(event) =>
                                                  handleBillingItemChange(
                                                    timesheetIndex,
                                                    billingItemIndex,
                                                    event
                                                  )
                                                }
                                                fullWidth
                                                InputProps={{
                                                  disableUnderline: true,
                                                  endAdornment:
                                                    item.type !==
                                                      "kilometers" ? (
                                                      <InputAdornment position="end">
                                                        <Select
                                                          value=""
                                                          onChange={(event) =>
                                                            handleBillingItemChange(
                                                              timesheetIndex,
                                                              billingItemIndex,
                                                              {
                                                                target: {
                                                                  name: "quantity",
                                                                  value:
                                                                    event.target
                                                                      .value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                          displayEmpty
                                                          IconComponent={
                                                            ArrowDropDownIcon
                                                          }
                                                          sx={{
                                                            "& .MuiSelect-select":
                                                            {
                                                              padding: 0,
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            },
                                                            "& .MuiOutlinedInput-notchedOutline":
                                                            {
                                                              border: "none",
                                                            },
                                                            "& .MuiPaper-root":
                                                            {
                                                              width: "100%",
                                                            },
                                                          }}
                                                          MenuProps={{
                                                            PaperProps: {
                                                              sx: {
                                                                maxHeight: 200, // Set the maximum height for the dropdown menu
                                                                overflowY: 'auto', // Enable vertical scrolling
                                                                "&::-webkit-scrollbar": {
                                                                  width: "8px", // Decrease the width of the scrollbar
                                                                },
                                                                "&::-webkit-scrollbar-thumb": {
                                                                  backgroundColor: "#888", // Color of the scrollbar thumb
                                                                  borderRadius: "4px", // Rounded corners for the scrollbar thumb
                                                                },
                                                                "&::-webkit-scrollbar-thumb:hover": {
                                                                  backgroundColor: "#555", // Color of the scrollbar thumb on hover
                                                                },
                                                              },
                                                            },
                                                          }}
                                                        >
                                                          {predefinedQuantities.map(
                                                            (quantity) => (
                                                              <MenuItem
                                                                key={quantity}
                                                                value={quantity}
                                                              >
                                                                {quantity}
                                                              </MenuItem>
                                                            )
                                                          )}
                                                        </Select>
                                                      </InputAdornment>
                                                    ) : null,
                                                }}
                                                placeholder={
                                                  item.type === "kilometers"
                                                    ? t('pages:timesheets.kilometers_placeholder')
                                                    : t('pages:timesheets.time_placeholder')
                                                }
                                                sx={commonTextFieldStyles}
                                              />
                                            </TableCell>
                                            {/* <TableCell>
                                              <FormGroup>
                                                <FormControlLabel
                                                  label="Billable"
                                                  control={
                                                    <Checkbox
                                                      name="billable"
                                                      checked={item.billable}
                                                      onChange={(event) =>
                                                        handleBillingItemChange(
                                                          timesheetIndex,
                                                          billingItemIndex,
                                                          event
                                                        )
                                                      }
                                                    />
                                                  }
                                                />
                                              </FormGroup>
                                            </TableCell> */}
                                            <TableCell>
                                              <Typography>
                                                €{" "}
                                                {item.type !== "kilometers"
                                                  ? (
                                                    parseFloat(item.rate) *
                                                    (parseInt(
                                                      item.quantity.split(
                                                        ":"
                                                      )[0]
                                                    ) +
                                                      parseInt(
                                                        item.quantity.split(
                                                          ":"
                                                        )[1]
                                                      ) /
                                                      60 +
                                                      parseInt(
                                                        item.quantity.split(
                                                          ":"
                                                        )[2]
                                                      ) /
                                                      3600)
                                                  ).toFixed(2)
                                                    .toString()
                                                    .replace(".", ",")
                                                  : (
                                                    parseFloat(item.rate) *
                                                    parseFloat(item.quantity)
                                                  ).toFixed(2)
                                                    .toString()
                                                    .replace(".", ",")}
                                              </Typography>
                                            </TableCell>
                                            <TableCell>
                                              <IconButton
                                                onClick={() =>
                                                  handleDeleteBillingItem(
                                                    timesheetIndex,
                                                    billingItemIndex
                                                  )
                                                }
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                  <Button
                                    variant="text"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={() =>
                                      handleAddBillingItem(timesheetIndex)
                                    }
                                    sx={{ mt: 2, textTransform: "none" }}
                                  >
                                    {t('pages:timesheets.add_billing_item')}
                                  </Button>
                                </TableContainer>
                                {/* </AccordionDetails>
                            </Accordion> */}
                              </TableCell>
                            </TableRow>
                          </AccordionDetails>
                        </Accordion>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          
          {/* Total summary and Add Timesheet button in the same row */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3, mb: 3 }}>
            {/* Total Duration and Amount moved to bottom left */}
            <Box sx={{ display: 'flex', gap: 4 }}>
              <Box>
                <Typography variant="subtitle1" component="div" sx={{ fontWeight: "bold" }}>
                  {t('pages:timesheets.total_duration')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: "1.2rem" }}>
                  {totalDurationDisplay === "NaNh: NaNm: NaNs" ? "0h:0m:0s" : totalDurationDisplay}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1" component="div" sx={{ fontWeight: "bold" }}>
                  {t('common:total_amount')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: "1.2rem" }}>
                  € {totalAmount.toFixed(2).toString().replace(".", ",")}
                </Typography>
              </Box>
            </Box>

            {/* Add Timesheet button moved to bottom right with no background */}
            <Button
              startIcon={<AddIcon />}
              onClick={() => handleAddTimesheet(selectedTimesheet)}
              sx={{ 
                textTransform: "none",
                backgroundColor: "transparent",
                color: "#2B80B6",
                borderColor: "#2B80B6",
                '&:hover': {
                  backgroundColor: 'rgba(43, 128, 182, 0.1)',
                },
                boxShadow: 'none'
              }}
            >
              {t('pages:timesheets.add_timesheet')}
            </Button>
          </Box>
          
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              // padding: "10px 16px",
              // background: "#fff",
              zIndex: 10,
              backgroundColor: "white",
              color: "#000000",
              padding: "13px 80px",
            }}
          >
            <CancelButton
              variant="outlined"
              onClick={handleCancel}
              size="small"
            >
              {t('buttons:secondary.cancel')}
            </CancelButton>
            <SubmitButton onClick={handleSubmit} size="small">
              {loading2 ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (t('pages:timesheets.create_button')
              )}
            </SubmitButton>
          </Box>
        </form>
      </Box>

      {/* Style for the timesheet list dropdown */}
      <style jsx global>{`
        .MuiAutocomplete-popper .MuiPaper-root .MuiAutocomplete-listbox .MuiAutocomplete-option {
          font-size: 0.75rem;
          padding: 8px 12px;
          min-height: 32px;
        }
        
        .MuiAutocomplete-popper .MuiPaper-root {
          max-height: 250px;
          overflow: hidden !important;
        }
        
        .MuiAutocomplete-popper .MuiPaper-root .MuiAutocomplete-listbox {
          padding: 8px 0;
          max-height: 250px !important;
          overflow-y: auto !important;
          scrollbar-width: thin;
        }
        
        .MuiAutocomplete-option {
          min-height: 32px;
        }
        
        .MuiAutocomplete-inputRoot {
          font-size: 0.875rem;
        }
        
        /* Style for case list items */
        .MuiAutocomplete-option .MuiStack-root {
          padding: 4px 0;
        }
        
        /* Hide any duplicate scrollbars */
        .MuiAutocomplete-popper .MuiPaper-root::-webkit-scrollbar {
          display: none !important;
        }
        
        .MuiAutocomplete-popper .MuiPaper-root {
          -ms-overflow-style: none !important;
          scrollbar-width: none !important;
        }
      `}</style>

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default BulkTimesheetPage;